exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n  .input-group-text {\n    position: absolute;\n    right:0;\n    top: 1;\n    margin-right: 27px;\n    margin-top: -43px;\n    border: none;\n    background: none;\n  }\n  \n  input {\n    padding-right: 30px; /* = icon width if you don't want the password to go under the icon */ \n    }\n    .text-black{\n        font-size: 18px !important;\n    }", ""]);

// exports
